import { IOptions, IObj } from '../types/common.types'
import { URL_SITE } from 'constants/data'
import { STATIC_URL } from '../data'

import {
  themeTexts,
  lectorTexts,
  specialityTexts,
  FilterTypeName,
  Key,
  pageKeys,
  IInitValues,
} from './search-data'
import { SubscibeURL, BASE_URL } from '../url'
import { formatSelect, formatCheckbox } from 'utils/search/formatParams'
import { IInitParams, IConfig } from '../types/search.types'
import { IBasicCard, IEventCard, IProjectCard } from '../types/card.types'

const Option = {
  future: 'Будущие',
  wantSee: 'Буду смотреть',
  past: 'Прошедшие',
  videoProjects: 'Видеопроекты',
}

const optionsLinks = {
  [Option.future]: `${URL_SITE}/webinar`,
  [Option.wantSee]: `${URL_SITE}/webinar/wantSee`,
  [Option.past]: `${URL_SITE}/webinar/past`,
  [Option.videoProjects]: `${URL_SITE}/webinar/videoprojects`,
}

//так сделано для совместимости со старыми ссылками с хэшами. После 05.2022 можно переделать
const OptionAliases = [
  {
    option: Option.future,
    alias: 'future',
  },
  {
    option: Option.wantSee,
    alias: 'wantSee',
  },
  {
    option: Option.past,
    alias: 'past',
  },
  {
    option: Option.videoProjects,
    alias: 'videoprojects',
  },
]

const options = [Option.future, Option.past, Option.wantSee, Option.videoProjects]
const unAuthOptions = [Option.future, Option.past, Option.videoProjects]

const executionTimes = [
  {
    label: 'Утро (08:00-12:00 МСК)',
    value: 'morning',
  },
  {
    label: 'День (12:00-18:00 МСК)',
    value: 'day',
  },
  {
    label: 'Вечер (18:00-20:00 МСК)',
    value: 'evening',
  },
]

const NMOCodes = [
  {
    label: 'Только с НМО',
    value: 'yes',
  },
]

const baseParams = {
  [Key.TEXT]: '',
  [Key.SPECIALITIES]: [],
  [Key.DATES]: [],
  [Key.LECTURS]: [],
  [Key.THEMES]: [],
  [Key.PAGE]: '1',
}

const InitParams: IObj<IInitParams> = {
  [Option.future]: {
    ...baseParams,
    [Key.EXECTUTION_TIME]: [],
    [Key.NMO]: [],
  },
  [Option.wantSee]: {
    ...baseParams,
    [Key.EXECTUTION_TIME]: [],
    [Key.NMO]: [],
  },
  [Option.past]: {
    ...baseParams,
    [Key.DURATION]: [],
  },
  [Option.videoProjects]: {
    ...baseParams,
  },
}

const InitValues: IInitValues = {
  params: {
    [Option.future]: InitParams[Option.future],
    [Option.wantSee]: InitParams[Option.wantSee],
    [Option.past]: InitParams[Option.past],
    [Option.videoProjects]: InitParams[Option.videoProjects],
  },
  pages: {
    [Option.future]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
    [Option.wantSee]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
    [Option.past]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
    [Option.videoProjects]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
  },
  cards: {
    [Option.future]: [] as IEventCard[],
    [Option.wantSee]: [] as IEventCard[],
    [Option.past]: [] as IBasicCard[],
    [Option.videoProjects]: [] as IProjectCard[],
  },
  allCount: {
    [Option.future]: 0,
    [Option.wantSee]: 0,
    [Option.past]: 0,
    [Option.videoProjects]: 0,
  },
}

const generateConfig = (
  lectures: IOptions[],
  themes: IOptions[],
  specialities: IOptions[],
  isTarget: boolean
): IObj<IConfig> => {
  const baseMainConfig = [
    {
      inputType: FilterTypeName.SELECT,
      themes: lectures,
      mobileSwitchBtnText: lectorTexts,
      title: 'Лектор',
      placeholder: 'Поиск по лекторам...',
      key: Key.LECTURS,
      formatter: formatSelect,
    },
    {
      inputType: FilterTypeName.SELECT,
      themes: themes,
      mobileSwitchBtnText: themeTexts,
      title: 'Тема',
      placeholder: 'Поиск по темам...',
      key: Key.THEMES,
      formatter: formatSelect,
    },
    !isTarget && {
      inputType: FilterTypeName.SELECT,
      themes: specialities,
      mobileSwitchBtnText: specialityTexts,
      title: 'Специальность',
      placeholder: 'Поиск по специальностям...',
      key: Key.SPECIALITIES,
      formatter: formatSelect,
    },
    {
      inputType: FilterTypeName.CHECKBOX,
      checkboxes: NMOCodes,
      noPCTitle: true,
      key: Key.NMO,
      formatter: formatCheckbox(NMOCodes),
    },
  ].filter((item) => item)

  const input = {
    placeholder: 'Поиск по названию...',
    key: Key.TEXT,
    sideIconPath: `${STATIC_URL}/filters/search-icon.svg`,
  }

  const baseOptionConfig = {
    input,
    main: baseMainConfig,
  }
  return {
    [Option.future]: baseOptionConfig,
    [Option.wantSee]: baseOptionConfig,
    [Option.videoProjects]: {
      input: {},
      main: [],
    },
    [Option.past]: {
      input,
      main: [
        {
          inputType: FilterTypeName.SELECT,
          themes: lectures,
          mobileSwitchBtnText: lectorTexts,
          title: 'Лектор',
          placeholder: 'Поиск по лекторам...',
          key: Key.LECTURS,
          formatter: formatSelect,
        },
        {
          inputType: FilterTypeName.SELECT,
          themes: themes,
          mobileSwitchBtnText: themeTexts,
          title: 'Тема',
          placeholder: 'Поиск по темам...',
          key: Key.THEMES,
          formatter: formatSelect,
        },
        !isTarget && {
          inputType: FilterTypeName.SELECT,
          themes: specialities,
          mobileSwitchBtnText: specialityTexts,
          title: 'Специальность',
          placeholder: 'Поиск по специальностям...',
          key: Key.SPECIALITIES,
          formatter: formatSelect,
        },
      ].filter((item) => item),
    },
  }
}

const URL = {
  [Option.future]: `${BASE_URL.WEBINAR}?StatusId=3&count=true`,
  [Option.wantSee]: `${SubscibeURL.WEBINAR}?StatusId=3&count=true`,
  [Option.past]: `${BASE_URL.WEBINAR}?StatusId=1&count=true`,
  // TODO: подумать, как в useCommonSearch не отправлять запросы для видео проектов
  [Option.videoProjects]: `${BASE_URL.WEBINAR}?StatusId=1&count=true`,
}

export {
  InitParams,
  generateConfig,
  InitValues,
  pageKeys,
  URL,
  options,
  unAuthOptions,
  Option,
  NMOCodes,
  executionTimes,
  OptionAliases,
  optionsLinks,
}
